import React, { FC } from 'react';
import Icon from '~ComponentsImproved/Icon';
import CheckIcon from '~Assets/icons/check.svg';
import { useButton } from '~Hooks';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';

const OptionWrapper = styled.div<{ dark?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 16px;
  color: ${({ dark }) => (dark ? 'var(--colorWhite)' : 'var(--colorBlueGray1200)')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

const Circle = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ active }) => (active ? 'var(--colorGradientGreen)' : 'transparent')};
  height: 24px;
  width: 24px;
  box-sizing: border-box;
  flex-shrink: 0;
  border-radius: 50%;
  border: ${({ active }) =>
    active ? '1px solid var(--colorGradientGreen)' : '1px solid var(--colorBlueGray400)'};
`;

export interface ListItem {
  id: string;
  name: string;
}

interface Props {
  id: string;
  name: string;
  description?: string;
  disabled?: boolean;
  active: boolean;
  onSelect: (id: string) => void;
  dark?: boolean;
  grid?: boolean;
}
const SelectListItem: FC<Props> = ({
  id,
  name,
  description,
  disabled,
  active,
  onSelect,
  dark,
}) => {
  const button = useButton({ onClick: () => (disabled ? null : onSelect(id)) });

  return (
    <OptionWrapper key={id} {...button} dark={dark} disabled={disabled}>
      <Circle active={active}>
        {active && <Icon src={CheckIcon} color="var(--colorWhite)" />}
      </Circle>
      {description ? (
        <Box display="flex" flexDirection="column">
          {name}
          <Paragraph level={5} color="var(--colorWhite)">
            {description}
          </Paragraph>
        </Box>
      ) : (
        <>{name}</>
      )}
    </OptionWrapper>
  );
};

export default SelectListItem;
